/**
 * LE NOM D'UN PAYS À PARTIR DE SON CODE.
 *
 * Ce module est SÉPARÉ de « translitteration.ts », et pour une raison précise :
 * celui-ci embarque « any-ascii », soit un demi-mégaoctet de tables. Le nom
 * d'un pays n'en a aucun besoin, et une trentaine d'écrans importent
 * « client-utils.ts » — les y faire tous passer par les tables serait un coût
 * pur, payé par tout le monde pour convertir « UA » en « Ukraine ».
 */

/**
 * « UA » n'est pas un pays, c'est un code. Stripe ne rend jamais autre chose
 * que l'alpha-2 d'ISO 3166-1, et l'écran comme le PDF l'affichaient brut —
 * « UA », « BE », « MQ ». Le pays n'est pourtant pas une décoration sur une
 * facture : il porte le régime de TVA, et il doit se lire.
 *
 * La table des noms est celle d'ICU, par « Intl.DisplayNames » : elle est déjà
 * dans Node comme dans les navigateurs, et se met à jour avec eux. Une table
 * écrite à la main ici vieillirait sans que personne ne s'en aperçoive.
 *
 * Une valeur qui n'est pas un code de deux lettres est rendue telle quelle :
 * les fiches saisies à la main portent « France » ou « Belgique », qu'il n'y a
 * rien à convertir.
 */
export function nomDuPays(valeur?: string | null): string {
    const brut = (valeur ?? "").trim();
    if (!/^[A-Za-z]{2}$/.test(brut)) return brut;

    const code = brut.toUpperCase();
    try {
        const nom = new Intl.DisplayNames(["fr"], { type: "region" }).of(code);
        return nom || code;
    } catch {
        // Environnement sans données de région : le code brut vaut mieux que rien.
        return code;
    }
}
